import { ApiRequestModel } from "../api_request_model";
import { BaseClass } from "../master/mastermodel";

export class ActorPersonalInfoRequest extends BaseClass {
 // public ConditionalOperator: number;
  public ActorCode: number;
  public Salutation: string;
  public FirstName: string;
  public MiddleName: string;
  public LastName: string;
  public DisplayName: string;
  public SocialSecurityNumber: string;
  public DateOfBirth: Date;
  public PlaceOfBirth: string;
  public Gender: string;
  public BloodGroup: string;
  public Nationality: string;
  public Religion: string;
  public BirthIdentification1: string;
  public BirthIdentification2: string;
  public LiveIn: string;
  public Occupation: string;
  public MaritalStatus: string;
  public HasWorkPermit: boolean;
  public IsConvicted: boolean;
  public LanguagesSpoken: string;
  public LanguagesRead: string;
 // public SendApiRequestModel: ApiRequestModel;

}

export class ActorPersonalInfoController {
  public ActorCode: number;
  public ActorTypeCode: number;
  public ActorType: string;
  public Salutation: string;
  public FirstName: string;
  public MiddleName: string;
  public LastName: string;
  public DisplayName: string;
  public FormattedCode: string;
  public DateOfBirth: Date;
  public PlaceOfBirth: string;
  public Gender: string;
  public GenderLongValue: string;
  public BloodGroup: string;
  public BloodGroupLongValue: string;
  public Nationality: string;
  public NationalityLongValue: string;
  public Religion: string;
  public ReligionLongValue: string;
  public BirthIdentification1: string;
  public BirthIdentification2: string;
  public LiveIn: string;
  public Occupation: string;
  public MaritalStatus: string;
  public MaritalStatusLongValue: string;
  public SocialSecurityNumber: string;
  public HasWorkPermit: boolean;
  public IsConvicted: boolean;
  public LanguagesSpoken: string;
  public LanguagesRead: string;
}
export class ActorContactInfoRequest extends BaseClass {
 // public ConditionalOperator: number;
  public ActorCode: number;
  public AddressLine1: string;
  public AddressLine2: string;
  public City: string;
  public State: string;
  public Country: string;
  public Telephone1: string;
  public Telephone2: string;
  public Fax1: string;
  public Fax2: string;
  public Email: string;
  public Website: string;
  public EmergencyContactPersonName: string;
  public EmergencyContactNo1: string;
  public EmergencyContactNo2: string;
  public EmergencyAddress: string;
  public RelationType: string; 
  //public SendApiRequestModel: ApiRequestModel;
}
export class EmergencyContactInfoController {
  public ActorCode: number;
  public ActorTypeCode: number; 
  public DisplayName: string; 
  public EmergencyContactPersonName: string; 
  public EmergencyContactNo1: string; 
  public EmergencyContactNo2: string; 
  public EmergencyAddress: string; 
  public RelationType: string;
  public EmergencyContactCode: number;
}
export class EmergencyContactInfoRequest extends BaseClass
{
  public ActorCode: number; 
  public AddressLine1: string; 
  public AddressLine2: string; 
  public EmergencyContactPersonName: string; 
  public EmergencyContactNo1: string; 
  public EmergencyContactNo2: string; 
  public EmergencyAddress: string; 
  public RelationType: string;
  public EmergencyContactCode: number;
}
export class SaveEmergencyContactInfoRequest extends BaseClass {

  public ActorCode: number;
  public EmergencyContactCode: number;

  public AddressLine1: string;
  public AddressLine2: string;
  public EmergencyContactPersonName: string;
  public EmergencyContactNo1: string;
  public EmergencyContactNo2: string;
  public EmergencyAddress: string;
  public RelationType: string;
  public RecordStatus: string;

}
export class ActorContactInfoController{
  public ActorCode: number;
  public ActorTypeCode: number;
  public AddressCode: number;
  public AddressType: number;
  public ActorType: string;
  public DisplayName: string;

  public AddressLine1: string;
  public AddressLine2: string;
  public City: string;
  public State: string;
  public Country: string;
  public CountryLongValue: string;
  public Telephone1: string;
  public Telephone2: string;
  public Fax1: string;
  public Fax2: string;
  public Email: string;
  public Website: string;
  public FormattedCode: string;
  public EmergencyContactPersonName: string;
  public EmergencyContactNo1: string;
  public EmergencyContactNo2: string;
  public EmergencyAddress: string;
  public RelationType: string;
  public PreferredHospital: string;
}


export class ActorLegalInfoRequest extends BaseClass {
  //public ConditionalOperator: number;
  public LegalCode: number;
  public ActorCode: number;
  public ChargeDate: Date;
  public Reason: string;
  public Charge: string;
  public Court: string;
  public Disposition: string;
  public State: string;
  public Remarks: string;
  public RecordStatus: string;
  //public SendApiRequestModel: ApiRequestModel;
}

export class ActorLegalInfoController {
  public LegalCode: number;
  public ActorCode: number;
  public Reason: string;
  public Charge: string;
  public ChargeDate: Date;
  public Court: string;
  public Disposition: string;
  public State: string;
  public Remarks: string;
  public RecordStatus: string;
  public ActorDocCode: number;
}
//export class ActorContactInfoRequest extends BaseClass
//{
//       // public long ConditionalOperator { get; set; }
//        public long ActorCode { get; set; }

//        public string AddressLine1 { get; set; }
//        public string AddressLine2 { get; set; }
//        public string City { get; set; }
//        public string State { get; set; }
//        public string Country { get; set; }
//        public string Telephone1 { get; set; }
//        public string Telephone2 { get; set; }
//        public string Fax1 { get; set; }
//        public string Fax2 { get; set; }
//        public string Email { get; set; }
//        public string Website { get; set; }
//        public string EmergencyContactPersonName { get; set; }
//        public string EmergencyContactNo1 { get; set; }
//        public string EmergencyContactNo2 { get; set; }
//        public string EmergencyAddress { get; set; }
//        public string RelationType { get; set; }

  
//}
export class EmploymentPreferencesRequest extends BaseClass {
  //public ConditionalOperator: number;
  public ActorCode: number;
  public Title: string;
  public Position: string;
  public HoursePerWeek: string;
  public ShiftType: string;
  public IsEmployed: boolean;
  public CanContactPresentEmployer: boolean;
  public IsNeedAccommodation: boolean;
  public ReasonForAccommodation: string;
  public WorkPreference: string;
  public ShiftDuration: string;
 // public SendApiRequestModel: ApiRequestModel;
}

export class ActorEducationInfoRequest extends BaseClass {
 // public ConditionalOperator: number;
  public EducationCode: number;
  public ActorCode: number;
  public InstituteName: string;
  public InstituteType: string;
  public Location: string;
  public CourseStudy: string;
  public StartFrom: Date;
  public CompletedAt: Date;
  public IsGraduate: boolean;
  public CourseType: string;
  public Subjects: string;
  public Remarks: string;
  public RecordStatus: string;
 // public SendApiRequestModel: ApiRequestModel;
}
//export class ServiceCategoryController {
//  public ShortName: string;
//  public ParentName: string;
//  public Code: number;
//  public CategoryName: string;
//  public ParentCode: number;
//  public ItemType: string;
//}
//export class ServiceCategoryRequest {
//  public ParentCode: number; 
//}
//export class ServicesByCategoryCodeRequest {
//  // public ConditionalOperator: number;
//  public Code : number;
//  public ActorCode: number;
//  public ServiceName: string;
//  public ServiceCategory : string;
//  public RecordStatus : string;
//  // public SendApiRequestModel: ApiRequestModel;
//}
export class ServiceBranchMapByFormattedCodeRequest {
  public CategoryName: string;
  public servicecategory: string;
  public servicename: string;
  public baseprice: number;
  public branchbaseprice: number;
  public commissionallowed: boolean;
  public RefundAllowed: boolean;
  public DiscountAllowed: boolean;
  public EditApprovalREquired: boolean;
  public SendApiRequestModel: ApiRequestModel;
  //public FormattedCode: number;
}

export class ActorEducationInfoController {
  public EducationCode: number;
  public ActorCode: number;
  public InstituteName: string;
  public InstituteType: string;
  public InstituteTypeLongValue: string;
  public Location: string;
  public CourseStudy: string;
  public StartFrom: Date;
  public CompletedAt: Date;
  public IsGraduate: boolean;
  public CourseType: string;
  public Subjects: string;
  public Remarks: string;
  public RecordStatus: string;
  public ActorDocCode: number;
}


export class ActorEmpHistoryInfoRequest extends BaseClass{
 // public ConditionalOperator: number;
  public EmpHistoryCode: number;
  public ActorCode: number;
  public EmployerName: string;
  public SupervisorName: string;
  public SupervisorTitle: string;
  public Address: string;
  public PhoneNo: string;
  public MayContact: boolean;
  public FromDate: Date;
  public ToDate: Date;
  public Duties: string;
  public Responsibilities: string;
  public ReasonForLeaving: string;
  public IsCurrent: boolean;
  public RecordStatus: string;
 // public SendApiRequestModel: ApiRequestModel;
}
export class ActorEmpHistoryInfoController {
  public EmpHistoryCode: number;
  public ActorCode: number;
  public EmployerName: string;
  public SupervisorName: string;
  public SupervisorTitle: string;
  public Address: string;
  public PhoneNo: string;
  public MayContact: boolean;
  public FromDate: Date;
  public ToDate: Date;
  public Duties: string;
  public Responsibilities: string;
  public ReasonForLeaving: string;
  public IsCurrent: boolean;
  public RecordStatus: string;
  public ActorDocCode: number;
}


export class ActorProfessionalReferenceRequest extends BaseClass {
 // public ConditionalOperator: number;
  public ProfessionalReferenceCode: number;
  public ActorCode: number;
  public FacilityName: string;
  public ContactPerson: string;
  public ContactPersonTitle: string;
  public Address: string;
  public PhoneNo: string;
  public RecordStatus: string;
 // public SendApiRequestModel: ApiRequestModel;
}
export class ActorProfessionalReferencesInfoController {
  public ProfessionalReferenceCode: number;
  public ActorCode: number;
  public FacilityName: string;
  public ContactPerson: string;
  public ContactPersonTitle: string;
  public Address: string;
  public PhoneNo: string;
  public RecordStatus: string;
  public ActorDocCode: number;
}
//
export class ActorEmploymentPreferencesRequest extends BaseClass {
 // public ConditionalOperator: number;
  public EmploymentPreferenceCode: number;
  public ActorCode: number;
  public Title: string;
  public Position: string;
  public HoursePerWeek: number;
  public ShiftType: string;
  public IsEmployed: boolean;
  public CanContactPresentEmployer: boolean;
  public IsNeedAccommodation: boolean;
  public ReasonForAccommodation: string;
  public WorkPreference: string;
  public ShiftDuration: string;
  public IsPrivate: boolean;
 // public SendApiRequestModel: ApiRequestModel;
}
export class ServiceCategoriesByFormattedCodeController {
  public ServiceCategoryCode: number;
  
  public ServiceCategoryName : string;
  public ShortName: string;
  public RecordStatus : string;
}

export class ActorEmploymentPreferencesInfoController{
  public ActorCode: number;
  public ActorTypeCode: number;
  public EmploymentPreferenceCode: number;
  public ActorType: string;
  public DisplayName: string;
  public Title: string;
  public Position: string;
  public HoursePerWeek: number;
  public ShiftType: string;
  public ShiftTypeLongValue: string;
  public IsEmployed: boolean;
  public CanContactPresentEmployer: boolean;
  public IsNeedAccommodation: boolean;
  public ReasonForAccommodation: string;
  public WorkPreference: string;
  public WorkPreferenceLongValue: string;
  public ShiftDuration: string;
  public ShiftDurationLongValue: string;
  public IsPrivate: boolean;
  public ReasonForAccommodationLongValue: string;
}

export class ActorProfileSummaryRequest extends BaseClass {
 // public ConditionalOperator: number;
  public HcpProfileCode: number;
  public ActorCode: number;
  public ProfileSummary: string;
 // public SendApiRequestModel: ApiRequestModel;
}

export class ActorProfileSummaryInfoController {
  public ActorCode: number;
  public ActorTypeCode: number;
  public HcpProfileCode: number;
  public ActorType: string;
  public DisplayName: string;
  public ProfileSummary: string;
}


////////////////////
export class ActorDashBoardProfileSummaryInfoRequest extends BaseClass {
  public ActorCode: number;
}

export class DashBoardProfileSummaryController {
  public DisplayName: string;
  public ProfileSummary: string;
  public ProfileTitle: string;
  public UpdateDate: Date;
  public Salutation: string;
  public FirstName: string;
  public MiddleName: string;
  public LastName: string;
  //public DisplayName1: string;
  public ActorType: string;
  public ActorTypeCode: number;
  public Line1: string;
  public Line2: string;
  public City: string;
  public Country: string;
  public State: string;
  public Zip: string;
  public Telephone1: string;
  public Telephone2: string;
  public Email: string;
  public AddressType: number;
  public HcpFormattedCode: string;
  public ActorImageFile: string;
  public ActorImageFileExtension: string;
  public ActorImageFileUrl: string;
  public ActorImageCode: number;
  public ActorCode: number;
  public HcpProfileCode: number;
  public AddressCode: number;
  public ActorAddressCode: number;
  public Speciality: string;
  public Position: string;
  public HoursePerWeek: number;
  public ShiftType: string;
  public ShiftTypeLongValue: string;
  public IsEmployed: boolean;
  public WorkPreferenceLongValue: string;
  public ShiftDurationLongValue: string;
}

// save data  + request for get
export class ActorPrefRequest extends BaseClass {
  public ActorPrefCode: number;
  public ActorCode: number;
  
  public PreferenceType: string;
  public Preference: string ;
  public Remarks: string;
  public RecordStatus: string;
  
}

// save data  + request for get
export class ActorPrefsInfoController extends BaseClass {
  public DisplayName: string;
  public ActorPrefCode: number;
  public ActorCode: number;
  public PreferenceTypeShortValue: string;
  public PreferenceTypeLongValue: string;  
  public Preference: string;
  public Remarks: string;  

}
// save data  + request for get
export class ActorSpecialtyRequest extends BaseClass
{
  public Remarks :string;
  public ActorCode: number;
  public Specialty: string;
  public DurationY: number;
  public DurationM: number;
  public TotalDuration: string;
  public TotalDurationText: string;
  public RecordStatus: string
  public ActorPrefCode: number;
  public ActorSpecialtyCode: number;
}

// get data - return value
export class ActorSpecialtyInfoController {
  public DisplayName: string;
  public ActorCode: number;
  public Specialty: string;
  public DurationY: number;
  public DurationM: number;
  public TotalDurationInMonths: number;
  public TotalDurationText: string;
  public RecordStatus: string;
  public EmployeeSpecialtyCode: number;
    }
//
export class ActorPersonalDetailInfoRequest extends BaseClass {
  public ActorCode: number;
  public Salutation: string;
  public FirstName: string;
  public MiddleName: string;
  public LastName: string;
  public DisplayName: string;
  public SocialSecurityNumber: string;
  public DateOfBirth: Date;
  public PlaceOfBirth: string;
  public Gender: string;
  public BloodGroup: string;
  public Nationality: string;
  public Religion: string;
  public BirthIdentification1: string;
  public BirthIdentification2: string;
  public LiveIn: string;
  public Occupation: string;
  public MaritalStatus: string;
  public HasWorkPermit: boolean;
  public IsConvicted: boolean;
  public LanguagesSpoken: string;
  public LanguagesRead: string;
  public AddressLine1: string;
  public AddressLine2: string;
  public City: string;
  public State: string;
  public Country: string;
  public Telephone1: string;
  public Telephone2: string;
  public Fax1: string;
  public Fax2: string;
  public Email: string;
  public Website: string;
  public EmergencyContactPersonName: string;
  public EmergencyContactNo1: string;
  public EmergencyContactNo2: string;
  public EmergencyAddress: string;
  public HcpProfileCode: number;
  public ProfileTitle: string;
  public ProfileSummary: string;
  public Zip: string;
}
//
export class ActorPersonalDetailInfoController {
  public ActorCode: number;
  public ActorTypeCode: number;
  public ActorType: string;
  public Salutation: string;
  public FirstName: string;
  public MiddleName: string;
  public LastName: string;
  public DisplayName: string;
  public FormattedCode: string;
  public DateOfBirth: Date;
  public PlaceOfBirth: string;
  public Gender: string;
  public GenderLongValue: string;
  public BloodGroup: string;
  public BloodGroupLongValue: string;
  public Nationality: string;
  public NationalityLongValue: string;
  public Religion: string;
  public ReligionLongValue: string;
  public BirthIdentification1: string;
  public BirthIdentification2: string;
  public LiveIn: string;
  public Occupation: string;
  public MaritalStatus: string;
  public MaritalStatusLongValue: string;
  public SocialSecurityNumber: string;
  public HasWorkPermit: boolean;
  public IsConvicted: boolean;
  public LanguagesSpoken: string;
  public LanguagesRead: string;
  public AddressCode: number;
  public AddressType: number;
  public AddressLine1: string;
  public AddressLine2: string;
  public City: string;
  public State: string;
  public Country: string;
  public CountryLongValue: string;
  public Telephone1: string;
  public Telephone2: string;
  public Fax1: string;
  public Fax2: string;
  public Email: string;
  public Website: string;
  public Zip: string;
  public EmergencyContactPersonName: string;
  public EmergencyContactNo1: string;
  public EmergencyContactNo2: string;
  public EmergencyAddress: string;
  public HcpProfileCode: number;
  public ProfileSummary: string;
  public UpdatedDateTime: Date;
  public ProfileTitle: string;
  public HcpProfileFormattedCode: string;
  public ActorImageFile: string;
  public ActorImageFileExtension: string;
  public ActorImageFileUrl: string;
  public ActorImageCode: number;
}
